import { useEffect } from "react";

export function useGmailOAuthCallback(
  handleCallback: (code: string) => Promise<void>,
) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code && state === "gmail_oauth") {
      // Clean up URL before async work so a refresh doesn't re-trigger
      const url = new URL(window.location.href);
      url.searchParams.delete("code");
      url.searchParams.delete("state");
      url.searchParams.delete("scope");
      window.history.replaceState({}, "", url.pathname + url.search);
      handleCallback(code);
    }
  }, [handleCallback]);
}
